import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import {
  AllPracticeListReq,
  PaginationRequestCommand,
  Practice,
  PracticeList,
  Response,
} from '../models';
import { PracticeAccountStatusResponse, UpdateAgreementAcceptanceReq } from '../models/practice.models';
@Injectable({
  providedIn: 'root',
})
export class PracticeService {
  private api: string = CONTROLLERS.PRACTICE;
  constructor(private apiService: ApiService) {}

  // getAllPracticeList(
  //   paginationRequestCommand: AllPracticeListReq
  // ): Observable<Response<PracticeList>> {
  //   return this.apiService.post(
  //     `${this.api}/${ENDPOINTS.PRACTICE.GET_ALL_PRACTICE}`,
  //     paginationRequestCommand
  //   );
  // }

  getPracticeById(id: number): Observable<Response<Practice>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE.GET_PRACTICE_BY_ID}/${id}`
    );
  }

  createPracticeWithBody(body: Practice): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PRACTICE.CREATE_PRACTICE_NO_AUTH}`,
      body
    );
  }

  updatePractice(formData: FormData): Observable<Response<any>> {
    return this.apiService.putMultipartFormData(
      '',
      `${this.api}/${ENDPOINTS.PRACTICE.UPDATE_PRACTICE}`,
      formData
    );
  }


  updatePracticeDataRefreshConfig(formData: FormData): Observable<Response<any>> {
    return this.apiService.putMultipartFormData(
      '',
      `${this.api}/${ENDPOINTS.PRACTICE.UPDATE_PRACTICE_DATA_REFRESH_CONFIG}`,
      formData
    );
  }

  updateSpecificEntityOfPractice(formData: FormData): Observable<Response<any>> {
    return this.apiService.putMultipartFormData(
      '',
      `${this.api}/${ENDPOINTS.PRACTICE.UPDATE_SPECIFIC_ENTITY_OF_PRACTICE}`,
      formData
    );
  }

  getPracticeDropdown() {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE.GET_PRACTICE_DROPDOWN}`
    );
  }

  getPracticeDropdownByMemberEmail(
    email: string
  ): Observable<Response<PracticeList>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PRACTICE.GET_PRACTICE_DROPDOWN_BY_MEMBER_EMAIL}`,
      {email}
    );
  }

  updateAgreementAcceptance(
      updateReqCommand: UpdateAgreementAcceptanceReq
    ): Observable<Response<boolean>> {
      return this.apiService.put(
        '',
        `${this.api}/${ENDPOINTS.PRACTICE.UPDATE_AGREEMENT_ACCEPTANCE}`,
        updateReqCommand
      );
    }

  resetPractice(practiceId: number): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PRACTICE.RESET_PRACTICE}`,
      { PracticeId: practiceId }
    );
  }
    getPracticeAccountStatus(id: number): Observable<Response<PracticeAccountStatusResponse>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE.GET_PRACTICE_ACCOUNT_STATUS}/${id}`
    );
  }

  updateWidgetStatusAsDownloaded(
      practiceId: number
    ): Observable<Response<boolean>> {
      return this.apiService.post(
        `${this.api}/${ENDPOINTS.PRACTICE.UPDATE_WIDGET_STATUS_AS_DOWNLOAD}`,
        {practiceId}
      );
    }

  generatePayNowScript(practiceId: number): Observable<Response<string>> {
    return this.apiService.getById(
      practiceId.toString(),
      `${this.api}/${ENDPOINTS.PRACTICE.GENERATE_PAY_NOW_SCRIPT}`
    );
  }
}
